import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'permanent_placements',
  inputShow: gql`
    query permanentPlacements($input: AssignmentQueryInput) {
      permanentPlacements(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  show: Show,
  edit: Edit,
  create: Create,
  options: {
    group: 'Misc',
    label: 'Permanent Placements',
  },
};
